import React, { memo } from 'react';
import { LinearProgressBarStyled } from './styles/LinearProgressBarStyled';

const LinearProgressBar = ({ progress }) => (
  <LinearProgressBarStyled progress={progress}></LinearProgressBarStyled>
);

export default memo(LinearProgressBar);
